import EnemyHelper from "./enemy.helper";
import PlayerHelper from "./player.helper";
import PointHelper from "./point.helper";
import config from "@/config";
var GameHandler = /** @class */ (function () {
    function GameHandler() {
        this.is_started = false;
        this.is_paused = true;
    }
    GameHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new GameHandler();
        }
        return this._instance;
    };
    GameHandler.prototype.load = function (scene) {
        this.scene = scene;
        return this;
    };
    GameHandler.prototype.init = function () {
        PlayerHelper.init(this.scene);
        PointHelper.init(this.scene);
        EnemyHelper.init(this.scene);
    };
    GameHandler.prototype.isPaused = function () {
        return !this.is_started || this.is_paused;
    };
    GameHandler.prototype.start = function (onTick, onEnd) {
        var _this = this;
        var _a;
        (_a = this.timer) === null || _a === void 0 ? void 0 : _a.destroy();
        this.timer = this.scene.time.addEvent({
            callback: function () {
                var count = _this.timer.getRepeatCount();
                onTick(count);
                if (count > 0)
                    return;
                _this.stop();
                onEnd();
            },
            delay: 1000,
            repeat: config.gameplay.time.repeat - 1,
            loop: false,
        });
        this.is_started = true;
        this.is_paused = false;
        this.is_ended = false;
    };
    GameHandler.prototype.stop = function () {
        this.is_ended = true;
        this.pause();
    };
    GameHandler.prototype.pause = function () {
        this.is_paused = true;
        this.scene.time.paused = true;
        this.scene.sound.volume = 0;
        this.scene.sound.stopAll();
    };
    GameHandler.prototype.resume = function () {
        if (this.is_ended)
            return;
        this.is_paused = false;
        this.scene.time.paused = false;
        this.scene.sound.volume = 1;
    };
    GameHandler.prototype.update = function () {
        if (this.isPaused())
            return;
        this.scene.player.move();
        this.scene.enemies.forEach(function (enemy) { return enemy.update(); });
    };
    GameHandler.prototype.restart = function () {
        this.is_ended = false;
        this.resume();
        this.is_started = false;
        //this.scene.scene.restart();
        //SplashGame.AdHandler.getInstance().showAds(AD_TYPE.INTERSTITIAL);
    };
    return GameHandler;
}());
export default GameHandler;
